import React, { Component } from 'react';
import axios from 'axios';
import { Link, type RouteComponentProps } from 'react-router-dom';

interface user {
  code?: string;
  password?: string;
  passwordConfirmation?: string;
  errorMessage?: string;
  user?: any;
}

interface userprops extends RouteComponentProps {}
class Registration extends Component<userprops, user> {
  state: user = {
    errorMessage: '',
    user: {},
  };

  handleChange = (e: React.ChangeEvent<HTMLInputElement>, key: string) => {
    this.setState({ [key]: e.target.value });
  };

  componentDidMount() {
    const myURL = new URL(window.location.href);
    myURL.searchParams.forEach((value, name, searchParams) => {
      if (name === 'code') {
        this.setState({ code: value });
        // this.confirmEmail(value);
      }
    });
  }

  resetPassword = async (event: { preventDefault: () => void }) => {
    const that = this;
    event.preventDefault();
    await axios
      .post(`${process.env.REACT_APP_API_SERVER}/auth/reset-password`, {
        code: that.state.code,
        password: that.state.password,
        passwordConfirmation: that.state.passwordConfirmation,
      })
      .then((res) => {
        this.setState({
          user: res.data,
        });
        if (res.status === 200 && res.data.jwt) {
          that.props.history.push('/dashboard');
        }
      })
      .catch((error) => {
        if (error.response) {
          console.error(error.response);
          this.setState({
            errorMessage: error.response.data.message[0].messages[0].message,
          });
        }
      });
  };

  render() {
    return (
      <div className="d-md-flex half">
        <div className="bg" style={{ backgroundImage: 'url("/images/bg_1.jpg")' }}></div>
        <div className="contents">
          <div className="container">
            <div className="row align-items-center justify-content-center">
              <div className="col-md-12">
                <div className="form-block mx-auto">
                  <div className="text-center mb-5">
                    <h3>{this.state.code}</h3>
                    <p className="mb-4 text-danger">{this.state.errorMessage} </p>
                  </div>
                  <form onSubmit={this.resetPassword}>
                    <div className="form-group first">
                      <label htmlFor="password">Password</label>
                      <input
                        type="password"
                        className="form-control"
                        placeholder="Your Password"
                        id="password"
                        onChange={(e) => {
                          this.handleChange(e, 'password');
                        }}
                      />
                    </div>
                    <div className="form-group last mb-3">
                      <label htmlFor="passwordConfirmation">Password Confirmation</label>
                      <input
                        type="password"
                        className="form-control"
                        placeholder="Your Password Confirmation"
                        id="passwordConfirmation"
                        onChange={(e) => {
                          this.handleChange(e, 'passwordConfirmation');
                        }}
                      />
                    </div>

                    <div className="d-sm-flex mb-5 align-items-center">
                      {/* <label className="control control--checkbox mb-3 mb-sm-0">
                        <span className="caption">Remember me</span>
                        <input type="checkbox" checked="checked" />
                        <div className="control__indicator"></div>
                      </label> */}
                      <span className="m-auto">
                        <Link to="/register" className="forgot-pass">
                          Signup
                        </Link>
                      </span>
                      <span className="m-auto">
                        <Link to="/forgot-password" className="forgot-pass">
                          Forgot Password
                        </Link>
                      </span>
                    </div>

                    <input type="submit" value="Log In" className="btn btn-block btn-primary" />
                  </form>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }
}

export default Registration;
